import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cd2834c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hint" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Click below to rename")
], -1))
const _hoisted_2 = { class: "input-profile-picture" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileProfilePicture = _resolveComponent("ProfileProfilePicture")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _withDirectives(_createElementVNode("input", {
      class: "input-username",
      placeholder: "Click to enter your name",
      type: "text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.displayName) = $event)),
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeUsername && _ctx.changeUsername(...args))),
      maxlength: "34"
    }, null, 544), [
      [_vModelText, _ctx.displayName]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ProfileProfilePicture, {
        "profile-picture": _ctx.profilePicture,
        "show-edit": true
      }, null, 8, ["profile-picture"])
    ])
  ]))
}